import {
  Box,
  Center,
  Image,
  Img,
  Text,
  VStack,
  Icon,
  Tooltip,
  Badge,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { BsExclamationTriangleFill } from 'react-icons/bs';
import { WarningSeverity } from '../../../../../../config/weatherWarnings';
import { resolveWeatherIconCode } from '../../../../../../util/weatherCodeMapper';

export default function TimelineItem(props) {
  const [image, setImage] = useState(null);
  const {
    weatherCode,
    period,
    temperature,
    handleOnClick,
    selected,
    warnings,
    onWarningClick,
  } = props;

  useEffect(() => {
    if (weatherCode) {
      const iconCode = resolveWeatherIconCode(weatherCode, period);
      import(`../../../../../../assets/weathericons/${iconCode}_g.png`)
        .then(img => setImage(img.default))
        .catch(e => console.error(e));
    }
  }, [weatherCode, period]);

  // Get highest severity warning for this hour
  const getHighestSeverity = () => {
    if (!warnings || warnings.length === 0) return null;

    const severityOrder = {
      [WarningSeverity.EXTREME]: 4,
      [WarningSeverity.DANGER]: 3,
      [WarningSeverity.WARNING]: 2,
      [WarningSeverity.INFO]: 1,
    };

    return warnings.reduce((max, w) => {
      return severityOrder[w.severity] > severityOrder[max.severity] ? w : max;
    });
  };

  const getSeverityColor = severity => {
    switch (severity) {
      case WarningSeverity.EXTREME:
        return 'red';
      case WarningSeverity.DANGER:
        return 'orange';
      case WarningSeverity.WARNING:
        return 'yellow';
      case WarningSeverity.INFO:
        return 'blue';
      default:
        return 'gray';
    }
  };

  const highestWarning = getHighestSeverity();
  const hasWarnings = warnings && warnings.length > 0;

  return (
    <Center
      minW={'50px'}
      onClick={handleOnClick}
      border={selected ? '1px solid #d9d9d990' : '0px'}
      borderRadius={5}
      position="relative"
    >
      <VStack spacing={0}>
        <Text textStyle={'timelineItem'}>{period}</Text>
        {image && <Img w={'100%'} src={image} alt="Weather Icon" />}
        <Text textStyle={'timelineItem'}>{temperature}º</Text>

        {/* Warning indicator */}
        {hasWarnings && (
          <Tooltip
            label={`${warnings.length} alerta${warnings.length > 1 ? 's' : ''} - Click para detalles`}
            hasArrow
          >
            <Badge
              colorScheme={getSeverityColor(highestWarning.severity)}
              fontSize="xs"
              px={1}
              py={0.5}
              borderRadius="full"
              cursor="pointer"
              onClick={e => {
                e.stopPropagation();
                if (onWarningClick && highestWarning) {
                  onWarningClick(highestWarning);
                }
              }}
              _hover={{
                transform: 'scale(1.1)',
              }}
              transition="transform 0.2s"
            >
              <Icon as={BsExclamationTriangleFill} boxSize={2.5} />
            </Badge>
          </Tooltip>
        )}
      </VStack>
    </Center>
  );
}
